import { PayloadAction } from '@reduxjs/toolkit';
import { getSavedAdmitadId } from 'lib/admitad';
import { SubscriptionBuyTrialAPICall } from 'reactApp/api/billing/subscription/SubscriptionBuyTrialAPICall';
import { SubscriptionQuickAPICall } from 'reactApp/api/billing/subscription/SubscriptionQuickAPICall';
import { getQueryParams, getUtmSourceString } from 'reactApp/appHelpers/settingsHelpers';
import { BillingBuyTemplates, BillingBuyViewTemplates, BuyApiParams } from 'reactApp/modules/buySubscription/buySubscription.types';
import { IBuySubscription } from 'reactApp/modules/fastCheckout/fastCheckout.types';
import { call, put, takeEvery } from 'redux-saga/effects';

import { FastCheckoutActions } from './fastCheckout.actions';

function* buySubscriptionHandler(action: PayloadAction<IBuySubscription>) {
    const { id, isTrial, isMobile, isVKPay = false } = action.payload;
    const api = isTrial ? new SubscriptionBuyTrialAPICall() : new SubscriptionQuickAPICall();

    yield put(FastCheckoutActions.update({ id, isCheckoutProcessing: true, data: { isLoading: true } }));

    try {
        const admitadId = yield call(getSavedAdmitadId);
        const { partner } = getQueryParams();

        const params: BuyApiParams = {
            admitad_uid: admitadId,
            product_id: id,
            source: getUtmSourceString(),
        };

        if (partner) {
            params.partner = partner;
        }

        if (isVKPay) {
            params.skin = BillingBuyTemplates.CHECKOUT_VKPAY_NOOFFER;
            params.view = BillingBuyViewTemplates.checkout;
        } else if (isMobile) {
            params.skin = BillingBuyTemplates.CLOUD_B2C_MOBILE;
        }

        // @ts-ignore
        const { data } = yield call(api.makeRequest, params);

        yield put(FastCheckoutActions.update({ id, isCheckoutProcessing: false, data: { checkoutLink: isTrial ? data.url : data.pw } }));
    } catch (error) {
        yield put(FastCheckoutActions.update({ id, isCheckoutProcessing: false, data: { hasError: true } }));
    }
}

export function* watchFastCheckout() {
    yield takeEvery(FastCheckoutActions.buySubscription.toString(), buySubscriptionHandler);
}
